import { render, staticRenderFns } from "./EditOurFeatures.vue?vue&type=template&id=2fe3443e&scoped=true&"
import script from "./EditOurFeatures.vue?vue&type=script&lang=js&"
export * from "./EditOurFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe3443e",
  null
  
)

export default component.exports